module.exports = __webpack_public_path__ + "media/add-vendors-bg.png";